import { of } from "rxjs";
import { IdErrorCore } from "../../../constants/IdErrorCore";
import { actionErrorThrowError } from "../../errors/actionError";
export var pathHandleCoopInvitePlayerError = function (action, state$, deps) {
    return of(actionErrorThrowError(IdErrorCore.CoopInvitePlayerErrors, action.statusCode));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/path/pathHandleCoopInvitePlayerError.ts
// module id = 1843
// module chunks = 3